<template>

    <div id="agility_tab" class="flex_content" >

        <div class="container data_table_view">
            <div v-if="dataLoaded">

                <TableWrapper tableContainerId="positions_table_container">

                    <template v-slot:tableHead>
                        <tr>
                            <th></th>
                            <th data-tooltip="Score de matching">%</th>
                            <th>{{ labels['ai'] }}</th>
                            <th>{{ labels['as'] }}</th>
                            <th>{{ labels['am'] }}</th>
                            <th>{{ labels['ac'] }}</th>
                            <th>{{ labels['ag'] }}</th>
                        </tr>
                    </template>

                    <template v-slot:tableBody>

                        <tr class=""
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >

                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>
                            <td class="matching_col"
                                :class="matchingClass(evaluation.saven_test.matching_score.toFixed(0))">
                                {{ evaluation.saven_test.matching_score.toFixed(0) }}%
                            </td>

                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.s3_agility_scores.ai.toFixed(0))">
                                    {{ evaluation.saven_test.s3_agility_scores.ai.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.s3_agility_scores.as.toFixed(0))">
                                    {{ evaluation.saven_test.s3_agility_scores.as.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.s3_agility_scores.am.toFixed(0))">
                                    {{ evaluation.saven_test.s3_agility_scores.am.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.s3_agility_scores.ac.toFixed(0))">
                                    {{ evaluation.saven_test.s3_agility_scores.ac.toFixed(0) }}
                                </div>
                            </td>
                            <td class="evaluation_item_name">
                                <div class="circle_score" :class="scoreClass(evaluation.saven_test.s3_agility_scores.ag.toFixed(0))">
                                    {{ evaluation.saven_test.s3_agility_scores.ag.toFixed(0) }}
                                </div>
                            </td>


                            <!-- <td class="evalution_item_name"
                                v-for="(score, key) in evaluation.saven_test.s3_agility_scores"
                                :index="key" :key="key" >
                                <div>{{ score.toFixed(0) }}</div>
                            </td> -->
                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>

</template>

<script>
import s3AgilitiesLabels from '@/locales/s3AgilitiesLabels'


export default {
    name: 'PostitionEvalsAgilityTab',
    props: ["evaluations", "currentPosition", "currentRef", "dataLoaded"],
    components: {},
    beforeCreate() {},
    data(){
        return {}
    },
    computed: {
        labels(){
            return s3AgilitiesLabels[this.$i18n.locale]
        }
    },
    methods: {
        matchingClass(val){
            if(val < 25){return 'low'}
            if(val >= 25 && val < 50){return 'middleLow'}
            if(val >= 50 && val < 75){return 'middleHigh'}
            if(val >= 75){return 'high'}
        },
        scoreClass(score){
            return "is_score_" + score
        }
    }
}
</script>

<style lang="scss" scoped>
th{
    text-align: center!important;
}
.sortable_column{
    cursor: pointer;
}
th.active{
    background: #d2ddea;
}
td{
    text-align: center;
    color: #8f9aaa;
    height: 42px!important;
    padding-top: 6px!important;
    padding-bottom: 6px!important;
}
.data_table_view {
    padding-top: 50px;
}
.evaluation_item_name{

    .circle_score{
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        font-weight: 600;
        font-size: 1.2rem;
        background: $info;
        color: $white;
        margin: auto;
        &.is_score_1{
            background-color: $score-diff5;
        }
        &.is_score_2{
            background-color: $score-diff4;
        }
        &.is_score_3{
            background-color: $score-diff3;
        }
        &.is_score_4{
            background-color: $score-diff2;
        }
        &.is_score_5{
            background-color: $score-diff1;
        }
    }
}
.matching_col{
    font-weight: 700;
    font-size: 1.25rem;
    &.low{
        color: $score-diff4;
    }
    &.middleLow{
        color: $score-diff3;
    }
    &.middleHigh{
        color: $score-diff2;
    }
    &.high{
        color: $score-diff1;
    }
}
.eval_username{
    text-align: left!important;
}
td.eval_username{
    text-align: left!important;
    font-weight: 500;
}
</style>